import * as React from 'react'
import cx from 'classnames'
import { useCurrency } from '@local/do-secundo-use-currency'
import { Trans } from '@local/translations'

export const ItemPrice = ({ preDiscountPrice, price, isInvalid }) => {
  const { currencyFormatter } = useCurrency()

  const renderDiscount = preDiscountPrice !== price

  if (renderDiscount) {
    return (
      <td
        data-testid='discount-item-price'
        className={cx(
          { 'line-through': isInvalid },
          'text-default text-right align-top'
        )}
      >
        <Trans
          i18nKey='item.price'
          values={{
            preDiscountPrice: currencyFormatter(preDiscountPrice),
            price: currencyFormatter(price)
          }}
          components={{
            PreDiscountPrice: (
              <span data-testid='pre-discount-price' className='line-through' />
            ),
            Price: <span data-testid='discount-price' />
          }}
        />
      </td>
    )
  }

  return (
    <td
      data-testid='item-price'
      className={cx(
        { 'line-through': isInvalid },
        'text-default text-right align-top'
      )}
    >
      {currencyFormatter(preDiscountPrice)}
    </td>
  )
}
